import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { LevStandardQueryMeta } from '../../web/ReactQueryProvider';

const BASE_QUERY_KEY = 'getTestimonialTemplateFormats';

const FORMATS_CACHE_MS = 5 * 60 * 1000;

export const useGetTestimonialTemplateFormats = ({
	enabled = true,
	impersonationContext,
	meta,
}: {
	enabled?: boolean;
	impersonationContext?: Api.IImpersonationContext;
	meta?: LevStandardQueryMeta;
} = {}) => {
	const userSession = useUserSession();

	return useQuery({
		queryFn: () =>
			userSession.webServiceHelper.callAsync<Api.IGoogleReviewPostTemplateFormat[]>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: 'googleBusiness/testimonial/templates',
				}),
				'GET'
			),
		enabled,
		meta: meta ?? { toastErrorMessage: 'Failed to load the testimonial card sizes.' },
		queryKey: [BASE_QUERY_KEY, impersonationContext],
		refetchOnWindowFocus: false,
		staleTime: FORMATS_CACHE_MS,
		gcTime: FORMATS_CACHE_MS,
	});
};
